import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  SvgIcon,
} from '@mui/material';

import FlightIcon from '@mui/icons-material/Flight';

import FlightSegmentCrewStack from '../../components/FlightSegmentCrewStack';
import FlightSegmentTimesStack from '../../components/FlightSegmentTimesStack';

import { SafetyEventReport } from '../../core/api/clients';
import { useAuthorizedFormData } from '../../core/context/AuthorizedFormDataContext';
import useSaveNewSafetyEvent from '../../core/api/hooks/safety-event/useSaveNewSafetyEvent';

function SafetyEventNewOptions({ data }: {
  data: SafetyEventReport[] }) {
  const [segments, setSegments] = React.useState<SafetyEventReport[]>([]);
  const [isOpen, setOpen] = React.useState<boolean>(false);

  const { mutate: saveNewSafetyEvent } = useSaveNewSafetyEvent();
  const navigate = useNavigate();
  const authorizedFormData = useAuthorizedFormData();

  React.useEffect(() => {
    if (data !== null && data.length > 0) {
      setSegments(data);
      setOpen(true);
    }
  }, [data]);

  const createFlight = (report: SafetyEventReport) => {
    saveNewSafetyEvent(report, {
      onSuccess: (safetyEventReports: SafetyEventReport) => {
        navigate(`${authorizedFormData.metadata?.route}/${safetyEventReports.id}/edit`, { replace: true });
      },
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth="xl"
      fullWidth
    >
      <DialogTitle>Multiple Segments Found</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please select the flight segment for which you want to create a form
        </DialogContentText>
        <List>
          {segments.map((safetyEvent: SafetyEventReport) => (
            <ListItem
              key={safetyEvent.createdOn}
              disablePadding
              sx={{ py: 0 }}
            >
              <ListItemButton
                sx={{ padding: 2 }}
                onClick={() => createFlight(safetyEvent)}
              >
                <ListItemIcon sx={{ ml: 2 }}>
                  <SvgIcon>
                    <FlightIcon />
                  </SvgIcon>
                </ListItemIcon>
                <ListItemText
                  primary={`${safetyEvent.aircraftNumber} | ${safetyEvent.departureAirport} - ${safetyEvent.landingAirport}`}
                  secondary={(
                    <Stack>
                      <FlightSegmentTimesStack
                        pushTime={safetyEvent.pushTime}
                        outTime={safetyEvent.outTime}
                        offTime={safetyEvent.offTime}
                        onTime={safetyEvent.onTime}
                        inTime={safetyEvent.inTime}
                      />
                      <FlightSegmentCrewStack
                        captain={safetyEvent.captain}
                        firstOfficer={safetyEvent.firstOfficer}
                        flightAttendant1={safetyEvent.flightAttendant}
                      />
                    </Stack>
                  )}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}

export default SafetyEventNewOptions;
